import indexOf from 'lodash-es/indexOf';
import {
  getCachedImageURLFromImageObject,
  getCachedVideoURLFromVideoObject,
} from './images';
import { isObjectOfType } from './objects';
// import { UPLOAD_STATE_UPLOADING } from './upload/constants';

let canPreload = true;
let preloadInterval = null;
let preloadedURLs = [];
const MAX_PRELOADED_URLS = 1000;

const preloadImage = src => {
  // only preload image which are not already cached.
  if (indexOf(preloadedURLs, src) < 0) {
    preloadedURLs.push(src);
    if (preloadedURLs.length >= MAX_PRELOADED_URLS) {
      preloadedURLs = preloadedURLs.slice(
        preloadedURLs.length - MAX_PRELOADED_URLS,
      );
    }
    if (canPreload) {
      clearInterval(preloadInterval);
      const img = new Image();
      img.onload = () => {
        canPreload = true;
      };
      img.onerror = () => {
        canPreload = false;
      };
      img.src = src;
    } else if (!preloadInterval) {
      // if we can't preload we must wait 5 sec before trying again
      // to avoid cloudinary cache issue
      preloadInterval = setInterval(() => {
        canPreload = true;
        preloadInterval = null;
      }, 5000);
    }
  }
};

export const preloadFromSlides = (slides, appInstanceId) => {
  slides.forEach(slide => {
    Object.values(slide.content.objects || {}).forEach(object => {
      if (isObjectOfType(object, 'image')) {
        const url = getCachedImageURLFromImageObject(object, {
          cacheKey: appInstanceId,
        });
        preloadImage(url);
      } else if (
        isObjectOfType(object, 'video') ||
        (isObjectOfType(object, 'rich') &&
          ['giphy', 'sketchfab', 'soundcloud'].includes(object.ludus.source))
      ) {
        preloadImage(object.ludus.thumbnail);
      }
    });
  });
};

export const preloadFromObject = (object, appInstanceId) => {
  if (isObjectOfType(object, 'image')) {
    const url = getCachedImageURLFromImageObject(object, {
      cacheKey: appInstanceId,
    });
    preloadImage(url);
  } else if (isObjectOfType(object, 'video')) {
    const thumbnailUrl = getCachedVideoURLFromVideoObject(object, {
      format: 'jpg',
    });
    preloadImage(thumbnailUrl);
  }
};
